// extracted by mini-css-extract-plugin
export default {"fullWidth":"nGvjy5inEVA690TEurOd"};